import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';

const ComingSoonLayout = styled.div`
  width: 100vw;
  min-height: 100vh;
  min-width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
  box-sizing: border-box;

  /* 1) 검정 반투명 오버레이 (맨 위)
    2) BG 이미지 (중간)
    3) 보라색 그라데이션 (맨 아래) */
  background:
  /* overlay as a gradient image */
  linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)),
  /* actual BG image, mobile: horizontal fit, desktop: vertical fit */
   url('/BG.jpg') center center / auto 100% no-repeat fixed,
  /* purple gradient fill */
  linear-gradient(150deg,rgb(0, 0, 0) 0%,rgb(0, 0, 0) 100%);
  
  /* 오버레이만 multiply, 나머지는 normal */
  background-blend-mode: multiply, normal, normal;

  /* 모바일에서는 가로에 맞추고, 웹에서는 세로에 맞춤 */
  @media (min-width: 768px) {
    background:
    /* overlay as a gradient image */
    linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)),
    /* actual BG image, desktop: vertical fit */
    url('/BG.jpg') center center / auto 100% no-repeat fixed,
    /* purple gradient fill */
    linear-gradient(150deg,rgb(0, 0, 0) 0%,rgb(0, 0, 0) 100%);
    
    /* 오버레이만 multiply, 나머지는 normal */
    background-blend-mode: multiply, normal, normal;
  }
`;

const Banner = styled.div`
  width: 90%;
  max-width: 400px;
  height: 80px;
  margin: 0 auto;
  margin-top: calc(var(--vh, 1vh) * 2);
  margin-bottom: calc(var(--vh, 1vh) * 2);
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  border-radius: 0;
  box-shadow: none;

  @media (max-width: 768px) {
    width: 80%;
    max-width: 300px;
    height: 60px;
    margin-top: calc(var(--vh, 1vh) * 1);
    margin-bottom: calc(var(--vh, 1vh) * 1);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 0;
    box-shadow: none;
  }
`;

const MainContent = styled.div`
  flex: 1 1 0;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 0 24px 0;
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  height: calc(var(--vh, 1vh) * 100 - 100px);

  @media (max-width: 768px) {
    max-width: 100vw;
  }
`;

const Title = styled.h1`
  font-size: 2.2rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 18px;
  text-align: center;
  text-shadow: 2px 2px 8px rgba(80, 40, 120, 0.18);
`;

const Subtitle = styled.p`
  font-size: 1.15rem;
  color: #f3eaff;
  margin-bottom: 30px;
  text-align: center;
`;

const VideoWrapper = styled.div`
  width: 60%;
  max-width: 800px;
  aspect-ratio: 16/9;
  margin-bottom: 28px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(80, 40, 120, 0.18);
  background: #000;

  @media (max-width: 768px) {
    width: 90%;
    max-width: 95vw;
    border-radius: 10px;
  }
`;

const InfoText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  height: 300px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  backdrop-filter: blur(10px);
  padding: 10px 0;
  text-align: center;
  color: #f3eaff;
  font-size: 1.2rem;
  line-height: 1;
  margin-top: 10px;
  font-weight: 500;
  font-family: 'Pretendard', 'Noto Sans KR';

  h1 {
    font-size: 2.3rem;
    color: #ffee00;
    margin: 0;
    text-align: center;
  }

  @media (max-width: 768px) {
      font-size: 0.8rem;
      max-width: 95vw;
      height: 200px;
      border-radius: 10px;

      h1 {
        font-size: 1.5rem;
      }
  }
`;



const DateText = styled.p`
  font-size: 0.8rem;
  line-height: 1.5;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.6rem;
  }
`;


const BottomSpacer = styled.div`
  width: 100%;
  height: 100px;
  @media (max-width: 768px) {
    height: 100px;
  }
`;

const ComingSoon = ({ videoUrl = 'https://www.youtube.com/watch?v=vrfs3Yp7Ick', onStartGame }) => {
  const clickCountRef = useRef(0); // useRef로 클릭 카운트 관리
  const longPressTimerRef = useRef(null); // 길게 누르기 타이머
  const isLongPressRef = useRef(false); // 길게 누르기 상태
  const titleClickCountRef = useRef(0); // 타이틀 클릭 카운트 관리

  // 개발자용 게임 시작 기능
  useEffect(() => {
    const handleKeyPress = (event) => {
      // 디버깅용 로그
      //console.log('Key pressed:', event.key, 'Ctrl:', event.ctrlKey, 'Shift:', event.shiftKey);
      
      // Ctrl + Shift + ? 키 조합으로 게임 시작 (물음표 - 안전한 키)
      if (event.ctrlKey && event.shiftKey && event.key === '?') {
        event.preventDefault();
        //console.log('Test mode activated!');
        //console.log('onStartGame function:', onStartGame); // 디버깅 추가
        if (onStartGame) {
          //console.log('Calling onStartGame...'); // 디버깅 추가
          onStartGame();
          //console.log('onStartGame called!'); // 디버깅 추가
        } else {
          //console.log('onStartGame is not defined!'); // 디버깅 추가
        }
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [onStartGame]);

  // 길게 누르기 시작
  const handleLongPressStart = () => {
    //console.log('Long press started'); // 디버깅 추가
    isLongPressRef.current = false;
    longPressTimerRef.current = setTimeout(() => {
      isLongPressRef.current = true;
      //console.log('Long press detected! Starting game...'); // 디버깅 추가
      if (onStartGame) {
        onStartGame();
      }
    }, 2000); // 2초 길게 누르기
  };

  // 길게 누르기 종료
  const handleLongPressEnd = () => {
    if (longPressTimerRef.current) {
      clearTimeout(longPressTimerRef.current);
      longPressTimerRef.current = null;
    }
    if (!isLongPressRef.current) {
      // 짧은 클릭 처리
      clickCountRef.current += 1;
      //console.log('Short click! Click count:', clickCountRef.current); // 디버깅 추가
      
      if (clickCountRef.current >= 3) {
        //console.log('3 clicks reached! Starting game...'); // 디버깅 추가
        clickCountRef.current = 0; // 카운트 리셋
        if (onStartGame) {
          onStartGame();
        }
      }
    }
    isLongPressRef.current = false;
  };

  // 타이틀 클릭 처리
  const handleTitleClick = () => {
    titleClickCountRef.current += 1;
    
    // 5번 클릭 시 개발자모드 활성화
    if (titleClickCountRef.current >= 5) {
      titleClickCountRef.current = 0; // 카운트 리셋
      if (onStartGame) {
        onStartGame();
      }
    }
    
    // 3초 후에 클릭 카운트 리셋
    setTimeout(() => {
      titleClickCountRef.current = 0;
    }, 3000);
  };

  // YouTube embed URL 생성
  const getEmbedUrl = () => {
    try {
      const urlObj = new URL(videoUrl);
      let videoId = urlObj.searchParams.get('v');
      if (!videoId) {
        const paths = urlObj.pathname.split('/');
        videoId = paths[paths.length - 1];
      }
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=0&modestbranding=1&rel=0&showinfo=0&playsinline=1&loop=1&playlist=${videoId}`;
    } catch {
      return videoUrl;
    }
  };

  return (
    <ComingSoonLayout>
      <Banner>
        {/* <img src="/YOUNGPOSSE_Logo.png?v=2" alt="YOUNG POSSE" /> */}
      </Banner>
      <MainContent>
        {/* <img 
          src="/BG.jpg" 
          alt="YOUNG POSSE" 
          style={{
            width: '300px',
            height: 'auto',
            objectFit: 'contain',
            //cursor: 'pointer' // 클릭 가능함을 표시
          }}
          onTouchStart={handleTitleClick}
          // onMouseDown={handleLongPressStart}
          // onMouseUp={handleLongPressEnd}
          // onTouchStart={handleLongPressStart}
          // onTouchEnd={handleLongPressEnd}
          // onMouseLeave={handleLongPressEnd}
        /> */}
        {/* <div style={{width: '300px', height: '200px'}}>
        </div> */}
        {/* <Title>7월18일 오후 6시!</Title> */}
        {/* <Subtitle>곧 새로운 리듬게임이 여러분을 찾아갑니다!</Subtitle> */}
        <VideoWrapper>
          <iframe
            width="100%"
            height="100%"
            src={getEmbedUrl()}
            title="Coming Soon Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ display: 'block', width: '100%', height: '100%' }}
          />
        </VideoWrapper>
        <InfoText>
          {/* <p onClick={handleTitleClick}>
            <strong style={{color: 'rgb(143, 211, 245)'}}>영파씨가 쏜다!</strong>
          </p>
          <p><strong>8월 6일(수) 오후 6시</strong>에 만나보실 수 있습니다!</p>
          <p>조금만 기다려주세요 😊</p> */}

          <h1><strong>이벤트가 종료되었습니다!</strong></h1>
          <p>많은 참여와 관심에 진심으로 <strong>감사드립니다</strong> 💝</p>
          <br/>
          <DateText><strong>당첨자는 2025년 9월 8일(월) (KST)</strong>부터 개별 안내 예정입니다.</DateText>
          <DateText style={{wordBreak: 'keep-all'}}><strong>모든 리워드(경품, 룰렛)는 2025년 9월 15일(월) (KST)</strong>부터
          <br/> 
          순차적으로 발송될 예정입니다.
          </DateText>
        </InfoText>
      </MainContent>
      <BottomSpacer />
    </ComingSoonLayout>
  );
};

export default ComingSoon; 